'use client'

import { useEffect, useState } from 'react'
import Carousel from 'react-simply-carousel'
import styles from './Slider.module.scss'

interface SliderPops extends React.PropsWithChildren {
	maxItems?: number
}

export const Slider: React.FC<SliderPops> = (props) => {
	const [activeSlide, setActiveSlide] = useState(0)

	useEffect(() => {
		setTimeout(() => {
			setActiveSlide(1)
		}, 1000)
	}, [])

	const max_items = Math.min(3, props.maxItems || 3)

	return (
		<>
			<Carousel
				activeSlideIndex={activeSlide}
				onRequestChange={setActiveSlide}
				speed={400}
				responsiveProps={[
					{
						maxWidth: 599,
						speed: 200,
						itemsToShow: 1,
						infinite: true,
						dotsNav: {
							show: true,
							containerProps: {
								style: {
									width: '100%',
									display: 'flex',
									justifyContent: 'center',
									gap: '10px',
									marginTop: '15px',
								},
							},
							itemBtnProps: {
								style: {
									height: 16,
									width: 16,
									borderRadius: '50%',
									border: 0,
								},
							},
							activeItemBtnProps: {
								style: {
									height: 16,
									width: 16,
									borderRadius: '50%',
									border: 0,
									background: 'black',
								},
							},
						},
						centerMode: true,
						containerProps: {
							style: {
								maxWidth: 'none',
								width: '100vw',
								userSelect: 'text',
								margin: '0 0 0 -4px',
							},
						},
						innerProps: {
							className: styles.overflowed,
						},
						itemsListProps: {
							style: {
								gap: '15px',
							},
						},
					},
					{
						minWidth: 600,
						itemsToShow: max_items,
						infinite: false,
						dotsNav: {
							show: false,
						},
						containerProps: {
							style: {
								maxWidth: '1280px',
								width: '100%',
								padding: '0 30px',
								justifyContent: 'stretch',
								userSelect: 'text',
							},
						},
						innerProps: {
							className: styles.overflowed,
						},
						itemsListProps: {
							style: {
								gap: '30px',
							},
						},
					},
				]}
				forwardBtnProps={{
					show: false,
				}}
				backwardBtnProps={{
					show: false,
				}}
			>
				{props.children}
			</Carousel>
		</>
	)
}
